import React from 'react'
import { useAuth } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';

const AdminProtectedRoute = ({ children }) => {
  const { user, loading, isAdmin } = useAuth()

  if (!loading && (!user || !isAdmin)) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default AdminProtectedRoute